import React from "react";
import Leftbar from "../../Containers/DashboardContainer/Component/Leftbar";
const RootLayout = ({ children, props }) => {
  return (
    <div
      style={{
        height: "calc(100svh - 95px)",

        display: "flex",
        flexDirection: "row",
        width: "100%",
      }}
    >
      <div style={{ width: "250px", height: "100%" }}>
        <Leftbar dim={props.dim} />
      </div>

      <div
        style={{
          flex: 1,
          height: "100%",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default RootLayout;
